import { FC, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTES } from "shared/constants/routes";

const LoginPage = lazy(
  () => import("pages/Login/index" /* webpackChunkName: "login" */)
);

const UsersPage = lazy(
  () => import("pages/Users/index" /* webpackChunkName: "users" */)
);

const ReportsPage = lazy(
  () => import("pages/Reports/index" /* webpackChunkName: "reports" */)
);

const EducationTypePage = lazy(
  () =>
    import("pages/EducationType/index" /* webpackChunkName: "education-type" */)
);

const EmployerPage = lazy(
  () => import("pages/Employer/index" /* webpackChunkName: "employer" */)
);

const ExperienceTitlePage = lazy(
  () =>
    import(
      "pages/ExperienceTitle/index" /* webpackChunkName: "experience-title" */
    )
);

const InstitutionPage = lazy(
  () => import("pages/Institution/index" /* webpackChunkName: "institution" */)
);

const QualificationPage = lazy(
  () =>
    import("pages/Qualification/index" /* webpackChunkName: "qualification" */)
);

const TemplatesPage = lazy(
  () => import("pages/Templates/index" /* webpackChunkName: "templates" */)
);

const ContactRequestsPage = lazy(
  () =>
    import(
      "pages/ContactRequests/index" /* webpackChunkName: "contact-requests" */
    )
);

const SummaryPage = lazy(
  () => import("pages/Summary/index" /* webpackChunkName: "summary" */)
);

const SeniorManagerialPage = lazy(
  () =>
    import(
      "pages/SeniorManagerial/index" /* webpackChunkName: "senior-managerial" */
    )
);

const ResponsibilityPage = lazy(
  () =>
    import(
      "pages/Responsibility/index" /* webpackChunkName: "responsibility" */
    )
);

const SignificantAchievementsPage = lazy(
  () =>
    import(
      "pages/SignificantAchievements/index" /* webpackChunkName: "significant-achievements" */
    )
);

const CoverLettersPage = lazy(
  () =>
    import("pages/CoverLetters/index" /* webpackChunkName: "cover-letters" */)
);

const PlanPricingPage = lazy(
  () => import("pages/PlanPricing/index" /* webpackChunkName: "plan-pricing" */)
);

const FlaggedPaymentsPage = lazy(
  () =>
    import("pages/FlaggedPayments/index" /* webpackChunkName: "plan-pricing" */)
);

const AffiliateLinkPage = lazy(
  () => import("pages/AffiliateLink/index" /* webpackChunkName: "affiliates" */)
);

const AffiliateReportsPage = lazy(
  () =>
    import(
      "pages/AffiliateReports/index" /* webpackChunkName: "affiliate-reports" */
    )
);

const AppRoutes: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path={ROUTES.LOGIN} element={<LoginPage />} />
      <Route path={ROUTES.USERS} element={<UsersPage />} />
      <Route path={ROUTES.REPORTS} element={<ReportsPage />} />
      <Route path={ROUTES.EDUCATION_TYPE} element={<EducationTypePage />} />
      <Route path={ROUTES.EMPLOYER} element={<EmployerPage />} />
      <Route path={ROUTES.EXPERIENCE_TITLE} element={<ExperienceTitlePage />} />
      <Route path={ROUTES.INSTITUTION} element={<InstitutionPage />} />
      <Route path={ROUTES.QUALIFICATION} element={<QualificationPage />} />
      <Route path={ROUTES.TEMPLATES} element={<TemplatesPage />} />
      <Route path={ROUTES.CONTACT_REQUESTS} element={<ContactRequestsPage />} />
      <Route path={ROUTES.SUMMARY} element={<SummaryPage />} />
      <Route
        path={ROUTES.SENIOR_MANAGERIAL_VALUES}
        element={<SeniorManagerialPage />}
      />
      <Route path={ROUTES.RESPONSIBILITY} element={<ResponsibilityPage />} />
      <Route
        path={ROUTES.SIGNIFICANT_ACHIEVEMENTS}
        element={<SignificantAchievementsPage />}
      />
      <Route path={ROUTES.COVER_LETTERS} element={<CoverLettersPage />} />
      <Route path={ROUTES.PLAN_PRICING} element={<PlanPricingPage />} />
      <Route path={ROUTES.FLAGGED_PAYMENTS} element={<FlaggedPaymentsPage />} />
      <Route path={ROUTES.AFFILIATES} element={<AffiliateLinkPage />} />
      <Route
        path={ROUTES.AFFILIATE_REPORTS}
        element={<AffiliateReportsPage />}
      />

      {/* keep least always */}
      <Route path="*" element={<>Page not found</>} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
